import React from 'react';
import { Box, Grid } from '@mui/material';

// The Deal Flow controls row, shared by the table view (views/startup_applications)
// and the board view (views/deal_flow_board).
//
// Why this exists: both views used to draw this row themselves, and the two copies
// kept drifting - different mt/mb, different gaps, one group capped at 75% while
// the other flexed, a stray marginTop on one search box. Every one of those showed
// up as "the header jumps when I switch views". Owning the geometry here means the
// two views cannot disagree about it again.
//
// Only the LAYOUT lives here. Each view still passes its own controls, because they
// genuinely differ - the table has AI Shortlist and its own kebab items, the board
// has its own actions dropdown - and their state and handlers stay in the views.
//
// Geometry is the board view's, which is the one signed off as correct.
const DealFlowToolbar = ({ left = null, right = null, sx = {} }) => (
  <Grid
    item
    xs={12}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '0.75rem',
      // Keep the search + filter group on the SAME row as the pipeline tabs at every
      // breakpoint (no wrapping to a second line). The tab strip is a scrollable MUI
      // TabList with minWidth:0, so it shrinks/scrolls to make room instead.
      flexWrap: 'nowrap',
      mt: 1,
      mb: 1,
      ...sx,
    }}
  >
    {/* Tabs + Add. flex 1 1 auto so it takes the leftover width, minWidth 0 so the
        tab strip can shrink instead of shoving the Add button out of the row. */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem', minWidth: 0, flex: { lg: '1 1 auto' } }}>
      {left}
    </Box>

    {/* Search + Filter + view toggle + actions. flexShrink 0 so these keep their
        size and the tab strip absorbs the slack. */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.625rem', flexShrink: 0, flexWrap: 'nowrap' }}>
      {right}
    </Box>
  </Grid>
);

export default DealFlowToolbar;
